<template>
  <div>
    <project-card @back="backProjectList" :projectData="projectData" v-if="status==='normal'"></project-card>
    <Tabs value="project">
      <div slot="extra">
        <div v-if="hasAccount" style="display:inline-block;padding:5px 16px 0 0;font-size:16px;vertical-align:middle;">保证金账号：<span style="color:#19be6b;">{{projectAccount.acctNo}}</span></div>
        <Button 
          v-if="canDownFile && status==='normal' && gzPermission" 
          :disabled="(hasAccount || canShowFile)" 
          type="primary" 
          size="small" 
          style="margin:5px 5px 0 0" 
          @click="createDepositAccount"
        >
          保证金账号创建
        </Button>
        <Button v-if="canDownFile" :disabled="!hasAccount && (!canShowFile && !createAccount)" type="primary" size="small" style="margin:5px 5px 0 0;" @click="downStandFile">保证金标准附件下载</Button>
        <Button type="primary" size="small" style="margin:5px 5px 0 0;" @click="bidFileDownload">采购相关文件下载</Button>
      </div>
      <TabPane label="项目及包组" name="project">
        <Card style="margin-top: 10px;">
          <div slot="title">挂网信息</div>
          <Form ref="operatorInfo" :model="operatorInfo" inline :label-width="100" :rules="operateValidate">
            <FormItem label="挂网" prop="spreadWeb">
              <Select v-model="operatorInfo.spreadWeb" multiple style="width:300px;position:relative;z-index:20">
                <Option v-for="item in spreadTypeArr" :value="item.itemCode" :key="item.itemCode">{{ item.itemName }}</Option>
              </Select>
            </FormItem>
            <FormItem label="报名费（元）" prop="enrollFee">
              <Input type="text" v-model="operatorInfo.enrollFee"></Input>
            </FormItem>
            <FormItem label="是否网上报名" prop="isWebEnroll">
              <Select v-model="operatorInfo.isWebEnroll" style="width:100px;">
                <Option value="是">是</Option>
                <Option value="否">否</Option>
              </Select>
            </FormItem>
            <FormItem label="是否按包组收费" :label-width="120" prop="isGroupPrice">
              <Select v-model="operatorInfo.isGroupPrice" style="width:100px;">
                <Option value="是">是</Option>
                <Option value="否">否</Option>
              </Select>
            </FormItem>
            <br />
            <FormItem label="跟进人员">
              <Input v-model="operatorInfo.merchandiser"></Input>
            </FormItem>
            <FormItem label="联系电话" prop="agencyContactNumber">
              <Input v-model="operatorInfo.agencyContactNumber" placeholder="供应商可通过此电话联系项目负责人" style="width:220px"></Input>
            </FormItem>
          </Form>
          <div style="width:100%;text-align:center;">
            <Button type="primary" @click="submitOperateInfo">确定</Button>
          </div>
        </Card>
        <Card style="margin-top: 10px;">
          <div slot="title">包组</div>
          <div slot="extra">
            <Button type="primary" size="small" @click="addGroup" :disabled="permission.projectStatusPermission || hasGroup">添加包组</Button>
          </div>
          <Table :columns="groupColumns" :data="groupList"></Table>
        </Card>
      </TabPane>
      <TabPane label="客户需求/委托协议" name="demand" v-if="status==='normal'">
        <demandFile :projectData="projectData" :editPermission="permission.projectStatusPermission"></demandFile>
      </TabPane>
      <TabPane label="文件审核" name="examine" v-if="status==='normal'">
        <file-examine :projectData="projectData"></file-examine>
      </TabPane>
    </Tabs>
    <group :status="status" :visible="groupVisible" :editPermission="permission.projectStatusPermission" :editGroup="editGroupData" :insertIndex="insertIndex" :projectData="projectData" @cancel="groupVisible=false" @editSuccess="editGroupSuccess"></group>
    <Modal v-model="standardFileVisible" :mask-closable="false" class="standardfile-modal">
      <iframe :src="standardFileUrl" style="width:98%;height:100%;border:1px solid #ddd;"></iframe>
    </Modal>
  </div>
</template>

<script>
import axios from 'axios'
import ajax from '@/lib/ajax'
import group from './group'
import fileExamine from './fileExamine'
import demandFile from './demandFile'
import requestUrls from '@/lib/requestUrls'
import projectCard from './projectCard'
import { fileUtil } from '@/lib/abpfile'
import { isWeiXin } from '@/lib/tool'

export default {
  name: 'editProject',
  props: {
    projectData: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      default: 'normal'
    },
    bidFileUrl: {
      type: String
    }
  },
  data() {
    return {
      groupVisible: false,
      groupColumns: [
        {
          title: '序号',
          key: 'groupNo',
          width: 80
        },
        {
          title: '名称',
          key: 'groupName'
        },
        {
          title: '采购预算',
          key: 'groupDudget',
          width: 120
        },
        {
          title: '应收款',
          key: 'groupReceivable',
          width: 120
        },
        {
          title: '交易情况',
          key: 'groupStatus',
          width: 100
        },
        {
          title: '操作',
          width: 150,
          render: (h, params) => {
            let disabled = true
            if (!this.permission.projectStatusPermission && this.status === 'normal') {
              disabled = false
            }
            return h('div', {
              style: {
                textAlign: 'center'
              }
            }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '10px'
                  },
                  on: {
                    click: () => {
                      this.editGroup(params.row)
                    }
                  }
                }, '查看编辑'),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    disabled: disabled
                  },
                  on: {
                    click: () => {
                      this.deleteGroup(params.row)
                    }
                  }
                }, '删除'),
              ])
          }
        }
      ],
      groupList: [],
      insertIndex: '',
      editGroupData: '',
      permission: {
        projectStatusPermission: false
      },
      standardFileUrl: '',
      standardFileVisible: false,
      canDownFile: false,
      projectAccount: '',
      hasAccount: false,
      canShowFile: false,
      createAccount: false,
      hasGroup: false,
      groupStatus: false,
      bidFileVisible: false,
      gzPermission: false,
      operatorInfo: {
        enrollFee: '',
        spreadWeb: ['采联国际'],
        isWebEnroll: '',
        merchandiser: '',
        bidFile: '',
        isGroupPrice: ''
      },
      operateValidate: {
        enrollFee: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        spreadWeb: [
          { required: true, type: 'array', message: '不能为空', trigger: 'change' }
        ],
        isWebEnroll: [
          { required: true, message: '不能为空', trigger: 'change' }
        ],
        isGroupPrice: [
          { required: true, message: '不能为空', trigger: 'change' }
        ],
        agencyContactNumber: [
          { required: true, message: '不能为空', trigger: 'change' }
        ]
      },
      spreadTypeArr: []
    }
  },
  components: {
    group,
    fileExamine,
    demandFile,
    projectCard
  },
  mounted () {
    this.getDataDict('挂网地址').then(res => {
      this.spreadTypeArr = res
    })
  },
  methods: {
    // 获取当前包组
    async getGroup() {
      let rep = await ajax.get(requestUrls.ClGroupDb.getPaged, {
        params: {
          filter: `projectId=="${this.projectData.id}"`,
          maxResultCount: 500,
          skipCount: 0
        }
      })
      if (rep.data.success) {
        // this.groupList = rep.data.result.items
        this.groupList = this.handleGroupList(rep.data.result.items)
        
        let projectStatus = ['预立项', '等待用户需求', '文件编制中', '标书文件已完成', '审查通过可挂网']
        if (rep.data.result.items.length > 0 && !this.groupStatus && this.status === 'extraEdit' && projectStatus.indexOf(this.projectData.projectState) === -1) {
          this.hasGroup = true
        }
        this.groupStatus = true
      }
    },
    backProjectList() {
      this.$emit('back')
    },
    editGroup(row) {
      this.editGroupData = row
      this.groupVisible = true
    },
    deleteGroup(row) {
      this.$Modal.confirm({
        title: '删除包组',
        content: `确认删除包组${row.groupName}？`,
        onOk: async () => {
          try {
            this.$Spin.show()
            let rep = await ajax.delete(requestUrls.ClGroupDb.Delete, {
              params: {
                id: row.id
              }
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('删除成功')
              this.getGroup()
            } else {
              this.$Message.error('删除失败')
            }
          } catch (err) {
            this.$Spin.hide()
            this.$Message.error('删除失败')
          }
        }
      })
    },
    addGroup() {
      // 限制进入4.0立项
			if (this.projectData.dataSource === '4.0立项') {
				this.$Modal.confirm({
					title: '温馨提示',
					content: '文件编制功能已转移到采联业务系统4.0，请前往采联业务系统4.0处理。',
					cancelText: '取消',
					okText: '立即前往',
					onOk: () => {
						if (isWeiXin()) {
							window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
						} else {
							window.open('https://qy.choicelink.cn:8440')
						}
					}
				})
				return
			}
      this.editGroupData = ''
      this.groupVisible = true
    },
    // 包组筛选空出位置插入
    handleGroupList(groupList) {
      let orderList = []
      groupList.forEach(group => {
        let index = parseInt(group.groupNo) - 1
        orderList[index] = group
      })
      let orderResult = []
      // 去除空数据并记录第一个空的位置
      this.insertIndex = ''
      for (let i = 0; i < orderList.length; i++) {
        let item = orderList[i]
        if (item) {
          orderResult.push(item)
        } else {
          if (this.insertIndex === '') {
            this.insertIndex = i + 1
          }
        }
      }
      if (this.insertIndex === '') {
        this.insertIndex = orderResult.length + 1
      }
      return orderResult
    },
    editGroupSuccess() {
      this.groupVisible = false
      this.getGroup()
    },
    downStandFile() {
      this.standardFileVisible = true
      let acctNo = ''
      if (this.projectAccount) {
        acctNo = this.projectAccount.acctNo
      }
      this.standardFileUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B8d28%5D%5B63a7%5D%5B62a5%5D%5B8868%5D%2F%5B4fdd%5D%5B8bc1%5D%5B91d1%5D%5B9644%5D%5B4ef6%5D%2FBond.cpt&xmjc=${this.projectData.projectShort}&xmxz=${this.projectData.projectProperty}&xmbh=${this.projectData.projectFull}&npid=${this.projectData.id}&bzjzh=${acctNo}`
    },
    createDepositAccount() {
      this.$Modal.confirm({
        title: '保证金账号创建',
        content: '确认创建保证金账号？',
        onOk: async () => {
          this.$Spin.show()
          try {
            let rep = await ajax.post(requestUrls.ClMargin.CreateAccount, {
              projectId: this.projectData.id,
              groupId: ''
            })
            // 刷新数据
            this.projectAccount = await this.getProjectAccountId(this.projectData.id)
            this.$Spin.hide()
            this.$Message.success('创建成功')
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('创建失败')
          }
        }
      })
    },
    async getProjectAccountId(projectId) {
      let rep = await ajax.get(requestUrls.ClMargin.GetByProjectId, {
        params: {
          projectId: projectId
        }
      })
      if (rep.data.success && rep.data.result) {
        this.hasAccount = true
        this.createAccount = true
        return rep.data.result
      }
      return null
    },
    // 采购相关文件下载
    bidFileDownload() {
      this.standardFileUrl = this.bidFileUrl
      this.standardFileVisible = true
    },
    submitOperateInfo() {
      this.$refs.operatorInfo.validate(async (valid) => {
        if (valid) {
          if (this.operatorInfo.enrollFee > 9999) {
            this.$Message.error('报名费不得超过9999元，请重新输入')
            return
          }
          this.$Spin.show()
          try {
            let rep = await ajax.put(requestUrls.ClProjectDb.UpdateNet, {
              id: this.projectData.id,
              entryFee: this.operatorInfo.enrollFee,
              net: this.operatorInfo.spreadWeb[0],
              net2: this.operatorInfo.spreadWeb[1],
              net3: this.operatorInfo.spreadWeb[2],
              net4: this.operatorInfo.spreadWeb[3],
              onlineApply: this.operatorInfo.isWebEnroll,
              merchandiser: this.operatorInfo.merchandiser,
              agencyContactNumber: this.operatorInfo.agencyContactNumber,
              isGroupPrice: this.operatorInfo.isGroupPrice
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('招标挂网信息提交成功')

              // 如果修改报名费
              let rep = await ajax.get(requestUrls.articles.getPaged, {
                params: {
                  filter: `a.objectId=="${this.projectData.id}"`,
                  maxResultCount: 100,
                  skipCount: 0
                }
              })
              let inviteArticles = []
              if (rep.data.success) {
                rep.data.result.items.forEach(item => {
                  if (item.ext2 === '74166') {     // 招标
                    inviteArticles.push(item)
                  }
                })
                if (inviteArticles.length > 0) {
                  let promises = []
                  inviteArticles.forEach(article => {
                    article.amount = this.operatorInfo.enrollFee
                    article.isApply = false
                    if (this.operatorInfo.isWebEnroll === "是") {
                      article.isApply = true
                    }
                    let promise = ajax.post(requestUrls.articles.CreateOrUpdate, {
                      abpArticles: article
                    })
                    promises.push(promise)
                  })
                  let results = await Promise.all(promises)
                }
              }
            } else {
              this.$Message.error('招标挂网信息提交失败')
            }
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('招标挂网信息提交失败')
          }
        }
      })
    },
    async getDataDict(type = '', ip = 0, id) {//ip控制是否只查询一级数据
      if (!type) {
        return []
      }
      let para = {}
      if (ip) {
        para = {
          filter: `itemType=="${type}"&&itemParent==""`
        }
      } else {
        para = {
          filter: `itemType=="${type}"`
        }
      }
      if (id) {
        para = {
          filter: `itemType=="${type}"&&itemParent=="${id}"`
        }
      }
      let rep = await ajax.get(requestUrls.AbpDataDict.GetList, {
        params: para
      })
      if (rep.data.success) {
        return rep.data.result.items
      }
      return []
    },
  },
  watch: {
    async projectData(val) {
      if (val) {
        this.hasGroup = false
        this.groupStatus = false
        this.createAccount = false
        this.canShowFile = false
        this.gzPermission = val.district === '广州' && val.pAttr === '政府采购' ? val.area === '省属' || val.area === '部级' : true
        this.getGroup()
        // 项目状态权限
        this.permission.projectStatusPermission = false
        if (val.projectState === '已挂网文件售卖中' || val.projectState === '开评标中') {
          this.permission.projectStatusPermission = true
          this.canShowFile = true
        }
        // 可以编辑的项目状态
        let projectStatus = ['预立项', '等待用户需求', '文件编制中', '标书文件已完成', '审查通过可挂网', '已挂网文件售卖中', '开评标中']
        if (this.status === 'extraEdit' && projectStatus.indexOf(val.projectState) !== -1) {
          this.permission.projectStatusPermission = false
        }

        this.canDownFile = false

        let limitTime = new Date('2018-11-15').getTime()
        let time = new Date(val.newProjectTime).getTime()
        if (time > limitTime) {
          this.canDownFile = true
        }
        // if (val.companyName.indexOf('分公司') === -1 && val.companyName.indexOf('军工事业部') === -1 && val.companyName.indexOf('战略中心') === -1) {
        //   this.canDownFile = false
        // }

        this.projectAccount = ''
        this.hasAccount = false
        this.projectAccount = await this.getProjectAccountId(this.projectData.id)
        // 公告信息
        this.operatorInfo.enrollFee = val.entryFee
        if (val.entryFee) {
          this.operatorInfo.enrollFee = val.entryFee.toString()
        }
        this.operatorInfo.isWebEnroll = val.onlineApply
        this.operatorInfo.isGroupPrice = val.isGroupPrice
        this.operatorInfo.spreadWeb = []
        if (val.net) {
          this.operatorInfo.spreadWeb.push(val.net)
        }
        if (val.net2) {
          this.operatorInfo.spreadWeb.push(val.net2)
        }
        if (val.net3) {
          this.operatorInfo.spreadWeb.push(val.net3)
        }
        if (val.net4) {
          this.operatorInfo.spreadWeb.push(val.net4)
        }
        if (this.operatorInfo.spreadWeb.length === 0) {
          this.operatorInfo.spreadWeb.push('采联国际')
        }
        this.operatorInfo.merchandiser = val.merchandiser
        this.operatorInfo.agencyContactNumber = val.agencyContactNumber
      }
    }
  },
  computed: {
    isFileExist() {
      return this.operatorInfo.bidFile.displayName ? true : false
    }
  }
}
</script>

<style lang="less">
.standardfile-modal {
  .ivu-modal {
    top: 5%;
    width: 1000px !important;
    height: 90%;
    .ivu-modal-content {
      height: 100%;
    }
    .ivu-modal-body {
      height: 90%;
    }
  }
}
</style>
